import axios from "axios"

const { 
    REACT_APP_URI_UNIQUE_DOCS: URI_UNIQUE_DOCS,
} = process.env

export const fetchUniqueDocs = async () => {
    const { data } = await axios.get(URI_UNIQUE_DOCS) 

    return data
}

export const saveUniqueDocs = async (docs) => {
    const { data } = await axios.put(URI_UNIQUE_DOCS, docs)
    return data
}
